import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const aboutApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      getAbout: query({
        query: () => "/about",
        transformResponse: (responseData) => {
          const loadedAbout = responseData.map((about) => {
            about.id = about._id;
            return about;
          });
          return loadedAbout;
        },
        meta: { requiresAuth: false },
      }),

      // Get subscription by ID endpoint
      getAboutById: query({
        query: (id) => `/about/${id}`,
        providesTags: (result, error, id) => [{ type: "About", id }],
      }),

      // Create a new survey endpoint
      // Invalidates the tag of the existing survey with the same ID when the new survey is created.
      createAbout: mutation({
        query: ({ recaptchaToken, ...values }) => ({
          url: "/about",
          method: "POST",
          body: {
            ...values,
            recaptchaToken,
          },
        }),
        invalidatesTags: ["About"],
      }),

      updateAbout: mutation({
        query: ({ id, recaptchaToken, ...values }) => ({
          url: `/about/${id}`,
          method: "PUT",
          body: {
            ...values,
            recaptchaToken,
          },
        }),
        invalidatesTags: (result, error, arg) => [
          { type: "About", id: arg.id },
        ],
      }),

      deleteAbout: mutation({
        query: ({ id }) => ({
          url: `/about/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: (result, error, arg) => [
          { type: "About", id: arg.id },
        ],
      }),
    };
  },
});

// Destructure and export hooks
export const {
  useCreateAboutMutation,
  useDeleteAboutMutation,
  useGetAboutByIdQuery,
  useGetAboutQuery,
  useUpdateAboutMutation,
} = aboutApiSlice;
